import { BoardingModule, SubFlow } from '../../configLookup/components/Props';
import styles from '../configInfo.module.css';
import { handleEdges, handleNodes } from './Functions';
import ReactFlow from 'reactflow';
import 'reactflow/dist/style.css';
import dagre from 'dagre';
import { useMemo } from 'react';
import SubFlowNode from './SubFlowNode';
import { VegaDivider, VegaFlex, VegaFont } from '@globalpayments/vega-react';

interface Props {
  SubFlows: SubFlow[];
  setBoardingModules: (boardingModules: BoardingModule[]) => any;
}

const SubFlows: React.FC<Props> = ({ SubFlows, setBoardingModules }) => {
  SubFlows.sort((a, b) => (a.ordinal < b.ordinal ? -1 : a.ordinal > b.ordinal ? 1 : 0)); // sorts so index is the same as id

  const onNodeClick = (event: any, node: any) => {
    const selectedSubFlow = SubFlows[node.id];
    setBoardingModules(selectedSubFlow.boardingModules);
  };

  const nodeTypes = useMemo(() => ({ moduleNode: SubFlowNode }), []);

  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));

  const nodeWidth = 500;
  const nodeHeight = 150;
  const nodes = handleNodes(SubFlows, false);
  const edges = handleEdges(SubFlows);

  const getLayoutedElements = (nodes: any, edges: any, direction = 'TB') => {
    dagreGraph.setGraph({ rankdir: direction, edgesep: 10, ranksep: 30, nodesep: 60 });

    nodes.forEach((node: { id: string }) => {
      dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
    });

    edges.forEach((edge: { source: string; target: string }) => {
      dagreGraph.setEdge(edge.source, edge.target);
    });

    dagre.layout(dagreGraph);

    nodes.forEach(
      (node: { id: string; targetPosition: string; sourcePosition: string; position: { x: number; y: number } }) => {
        const nodeWithPosition = dagreGraph.node(node.id);
        node.targetPosition = 'top';
        node.sourcePosition = 'bottom';

        // We are shifting the dagre node position (anchor=center center) to the top left
        // so it matches the React Flow node anchor point (top left).
        node.position = {
          x: nodeWithPosition.x - nodeWidth / 2,
          y: nodeWithPosition.y - nodeHeight / 2,
        };

        return node;
      },
    );

    return { nodes, edges };
  };

  const { nodes: layoutNodes, edges: layoutEdge } = getLayoutedElements(nodes, edges);
  return (
      <VegaFlex direction="col" gap="size-8">
        <VegaFont as="h2" color="text-primary" variant="font-h4">SubFlows</VegaFont>
        <VegaDivider />
        <div className={styles.reactBoarding}>
          <ReactFlow nodeTypes={nodeTypes} nodes={layoutNodes} edges={layoutEdge} onNodeClick={onNodeClick} fitView />
        </div>
      </VegaFlex>
  );
};

export default SubFlows;
